import { useCallback, useRef } from "react";

/**
 * Custom hook to prevent horizontal scroll containers from capturing vertical scroll wheel events
 * This ensures the page scrolls normally even when the cursor is over a horizontal scroll container
 */
const usePreventHorizontalScroll = () => {
  // Use a ref to store the cleanup function
  const cleanupRef = useRef(null);

  // Use useCallback as a callback ref to handle element mounting/unmounting
  const setRef = useCallback((node) => {
    // Cleanup previous listener if it exists
    if (cleanupRef.current) {
      cleanupRef.current();
      cleanupRef.current = null;
    }

    if (node) {
      const handleWheel = (e) => {
        // If scrolling vertically
        if (e.deltaY !== 0) {
          e.preventDefault();
          e.stopPropagation();
          window.scrollBy({
            top: e.deltaY,
            behavior: "auto",
          });
        }
      };

      // Attach listener
      node.addEventListener("wheel", handleWheel, { passive: false });

      // Store cleanup function
      cleanupRef.current = () => {
        node.removeEventListener("wheel", handleWheel);
      };
    }
  }, []);

  return setRef;
};

export default usePreventHorizontalScroll;
